<template lang="html">
  <article class="slds-card slds-box slds-text-align_left">

    <div class="slds-text-heading_large">GUIDA ALL&rsquo;UTILIZZO</div>
     <hr/>
    <div class="slds-text-heading_medium"><p>Come accedere alle immagini dei prodotti:</p></div>
        
    <br/>
    <div class="slds-text-heading_small">
      Nella sezione &ldquo;Prodotti&rdquo; si trova l&rsquo;elenco dei prodotti (organizzato per campagne)      
    </div>
    <br/>
    <img src="/images/helpimage1.png" />
    <br/>
    <br/>
    <br/>
    <div class="slds-text-heading_small">
      Si può scaricare un file excel (in formato CSV) dell’elenco prodotti tramite il bottone in alto a destra
    </div>
    <br/>
    <img src="/images/helpimage3.png" />

    <br/>
    <br/>
    <br/>
    <div class="slds-text-heading_small">
      Nell’elenco sono presenti i prodotti ricevuti o in transito<br/>
      Di ogni prodotto si trova:
      <ul>
        <li>- Il prezzo di vendita al pubblico (PVP)</li>
        <li>- Lo stato dello scatto:
          <ul>
            <li>non previsto (indica che le fotografie non verranno fatte),</li>
            <li>da scattare (indica che le fotografie sono in produzione)</li>
            <li>scattato (indica che le fotografie sono già state fatte e sono disponibili al download)</li>
          </ul>
        </li>
        <li>- Il numero degli scatti: indica il numero di fotografie presenti sul portale per ogni prodotto</li>
      </ul>
    </div>
    <br/>
    <br/>
    <div class="slds-text-body_small">
      ATTENZIONE:<br/>
      La piattaforma impiega qualche momento per recuperare le immagini e renderle disponibili per il download:
    </div>
    <br/>
    <img src="/images/helpimage2.png" />
    <br/>
    <br/>
    <br/>
    <div class="slds-text-heading_small">
      È possibile scaricare le immagini singolarmente cliccando sulla singola immagine o massivamente cliccando sul bottone “Scarica tutti”:
    </div>
    <br/>
    <img src="/images/helpimage5.png" />
    <br/>
    <br/>
    <br/>
    <div class="slds-text-heading_small">
      Puoi effettuare il logout cliccando in alto a destra (da fare solo se ricordi le credenziali di accesso inviate via email)
    </div>
    <br/>
    <img src="/images/helpimage4.png" />

    <br/>
    <br/>
     <div class="slds-text-heading_large">Per ulteriori richieste &egrave; possibile scrivere a:
      <a href="mailto:scuola1@fcp.it">cscommerciale@fcp.it</a></div>

  </article>

</template>

<script>
  export default {
    name: 'homehelp2',
  }
</script>

<style scoped>

</style>